import { render, staticRenderFns } from "./AccountableAssets.vue?vue&type=template&id=3363ba7e"
import script from "./AccountableAssets.vue?vue&type=script&lang=js"
export * from "./AccountableAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports